import _curry3 from "./internal/_curry3";
import _isObject from "./internal/_isObject";
import mergeWithKey from "./mergeWithKey";
var mergeDeepWithKey = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
    return mergeWithKey(function (k, lVal, rVal) {
        if (_isObject(lVal) && _isObject(rVal)) {
            return mergeDeepWithKey(fn, lVal, rVal);
        }
        else {
            return fn(k, lVal, rVal);
        }
    }, lObj, rObj);
});
export default mergeDeepWithKey;
//# sourceMappingURL=mergeDeepWithKey.js.map